var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.editing)?_c('Checkbox',{attrs:{"value":_vm.value,"val":_vm.val,"label":_vm.label,"disabled":_vm.disabled,"hideDetails":_vm.hideDetails},on:{"change":function($event){return _vm.$emit('change', $event)}}}):_c('Value',{attrs:{"value":_vm.translatedValue,"displayTitle":_vm.displayTitle,"bold":_vm.boldValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }